import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconUserValidation from '@/icons/UserValidation.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { useGetArticleName } from '@/models/article';
import type { TNotificationOfType } from '@/models/notification';

export const InitialQuoteAcceptedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'initial_quote_accepted'>;
}) => {
  const { t } = useLingui();
  const getArticleName = useGetArticleName();
  const articleName = notification.article
    ? getArticleName({ article: notification.article })
    : null;
  const reference = notification.request.reference;

  return (
    <BaseNotification
      icon={<IconUserValidation />}
      type="primary"
      notification={notification}
      notificationLabel={
        articleName
          ? t({
              id: 'notification.initial-quote-accepted.with-article.label',
              message: `Quote approved for the item ${articleName} of request ${reference}`,
            })
          : t({
              id: 'notification.initial-quote-accepted.label',
              message: `Quote approved for request ${reference}`,
            })
      }
      notificationHeader={(color) =>
        articleName ? (
          <Trans id="notification.initial-quote-accepted.with-article">
            <InlineText weight="medium" color={color}>
              The client
            </InlineText>{' '}
            approved the quote for{' '}
            <InlineText weight="medium" color={color}>
              {articleName}
            </InlineText>
          </Trans>
        ) : (
          <Trans id="notification.initial-quote-accepted">
            <InlineText weight="medium" color={color}>
              The client
            </InlineText>{' '}
            approved the quote
          </Trans>
        )
      }
    />
  );
};
